module.exports = __webpack_public_path__ + "img/V5.a375d4db.jpg";